import script from "./TableGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./TableGenerator.vue?vue&type=script&setup=true&lang=js"

import "./TableGenerator.vue?vue&type=style&index=0&id=1a3822f3&lang=scss&ped=true"

const __exports__ = script;

export default __exports__